import { render, staticRenderFns } from "./SchoolRequests.vue?vue&type=template&id=6e321ea6&scoped=true&"
import script from "./SchoolRequests.vue?vue&type=script&lang=js&"
export * from "./SchoolRequests.vue?vue&type=script&lang=js&"
import style0 from "./SchoolRequests.vue?vue&type=style&index=0&id=6e321ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e321ea6",
  null
  
)

export default component.exports